function mainRender() {
  $(function () {
    $('#root').css('zoom', 'normal')
    let scale = document.body.clientWidth / 1080
    $('#root').css('zoom', scale)

    window.addEventListener(
      'resize',
      (function () {
        var timer
        return function () {
          if (timer) clearTimeout(timer)
          timer = setTimeout(function () {
            $('#root').css('zoom', 'normal')
            let scale = document.body.clientWidth / 1080
            $('#root').css('zoom', scale)
          }, 100)
        }
      })()
    )
    var swiper1 = new Swiper('.mySwiper1', {
      loop: true,
      direction: 'vertical',
      autoplay: {
        delay: 1000,
        reverseDirection: true,
        stopOnLastSlide: false,
        disableOnInteraction: false,
      },
    })
    // var stringEl = $('.str3').liMarquee({
    //   loop: -1,
    // })
    // 头部固定
    $('header').addClass('stiky')
    $(document).scroll(function (e) {
      setTimeout(function () {
        $('header').addClass('stiky')
      }, 50)
    })
    // 初始化
    alignmentFns.initialize()
    $('#2').change(function () {
      var number = Number($('#2').val())
      $(this)
        .parents()
        .siblings('.sp-price')
        .children()
        .children('.new')
        .html((number * Number(window.product[0].price / 100)).toFixed(2))
      $(this)
        .parents()
        .siblings('.sp-price')
        .children()
        .children('.old')
        .html(
          (number * Number(window.product[0].compare_at_price / 100)).toFixed(2)
        )
    })
    $('#3').change(function () {
      var number = Number($('#3').val())
      $(this)
        .parents()
        .siblings('.sp-price')
        .children()
        .children('.new')
        .html((number * Number(window.product[1].price / 100)).toFixed(2))
      $(this)
        .parents()
        .siblings('.sp-price')
        .children()
        .children('.old')
        .html(
          (number * Number(window.product[1].compare_at_price / 100)).toFixed(2)
        )
    })
    $('.sp-buynow').click(function () {
      let num = $(this).siblings('.sp-number').find('input').val()
      let id = $(this).attr('data-id')
      window.location.href = '/cart/' + id + ':' + num
    })
    function addCart() {
      // 加入购物车
      let initNum = 0
      $('.product-part .cart-btn').click(function () {
        if (swiper.realIndex == 0) {
          return
        }
        if (swiper.realIndex > 0) {
          var indes = swiper.realIndex
          var img = $('#swiper2 .swiper-slide').eq(indes).children('img')
        }
        initNum = initNum + 1
        $('#calcNumber').val(1)
        $('#cardNum').html(initNum)

        var flyer = img[0].cloneNode(true)
        flyer.classList.add('sp_clone')
        var offset = $('.sp-cart')[0].getBoundingClientRect()
        $('.product-part').append(flyer)
        $('.sp_clone').css({
          width: img[0].width,
          height: img[0].height,
          position: 'fixed',
          top: img[0].offsetTop,
          left: img.offset().left,
          'z-index': '9999',
        })

        let finish = $('.sp-cart')
        $('.sp_clone').animate(
          {
            top: finish[0].offsetTop,
            left: finish[0].offsetLeft + finish.width() / 2,
            width: 50, // 结束时的大小，根据需要调整
            height: 50, // 结束时的大小，根据需要调整
            opacity: 0.4,
            'z-index': '9999',
          },
          500,
          'linear',
          function () {
            $(this).animate(
              {
                width: 0,
                height: 0,
                opacity: 0,
              },
              0,
              function () {
                $('.sp-header-top .sp-cart').addClass('sp-shake')
                setTimeout(function () {
                  $('.sp-header-top .sp-cart').removeClass('sp-shake')
                }, 400)
                $(this).detach()
              }
            )
          }
        )
      })
    }
  })
  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
    const config = {
      rootMargin: '0px 0px 1300px 0px',
      threshold: 0,
    }

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target
          const dataSrc = image.getAttribute('data-src')
          image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image) // 停止观察该图片
        }
      })
    },
    config)

    images.forEach(function (image) {
      lazyLoadObserver.observe(image) // 开始观察每个图片
    })
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach(subArray => {
        subArray.forEach(url => {
          const img = new Image()
          img.src = url
        })
      })
    } else {
      // 处理一维数组
      imageArray.forEach(url => {
        const img = new Image()
        img.src = url
      })
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    lazyLoadImages()

    // preloadImages(imagesOneDim)
    // preloadImages(imagesTwoDim)

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]')
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault() // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById('shopping') // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop
        window.scroll({
          top: offsetTop * $('div#root').css('zoom'),
          behavior: 'smooth', // 使用 smooth 实现平滑滚动
        }) // 方式二
      })
    })
  })

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera
  var isAndroid = /android/i.test(userAgent)
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log('Android')
  } else if (isIOS) {
    console.log('iOS')
  } else if (isPC) {
    console.log('PC')
  } else {
    $('.sp_system').css('letter-spacing', '-4px')
  }
}

mainRender()
